exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".messages-list[data-v-5da4fd01]{height:100%;overflow-y:scroll;padding-bottom:160px}", ""]);

// exports
